import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {Ref, ref} from "vue";
import {useRouter} from "vue-router";
import axios from "axios";
import {useRootStore} from "@/store";
import {Alert} from "@/store/classes";
import {ContactUserAuthViewModel, ContactUserSecurityQuestion} from "@/store/classes";
import {ExternalFacilityType, VerificationFormStep} from "@/store/enums";
import ContactVerificationForm from "@/components/portal/ContactVerificationForm.vue3.vue";
import InviteForm from "@/components/InviteForm.vue3.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PortalInviteView.vue3',
  props: {
    inviteKey: {}
  },
  setup(__props: any) {

const props = __props;

const rootStore = useRootStore();
const router = useRouter();

const showAlert = (alert: Alert) => rootStore.dispatch('showAlert', alert);
const showLoader = (loaderName: string) => rootStore.dispatch('showLoader', loaderName);
const hideLoader = (loaderName: string) => rootStore.dispatch('hideLoader', loaderName);

const securityQuestions = ref<ContactUserSecurityQuestion[]>([]);
const currentValidationCode = ref();

async function loadForm({ validationCode, currentStep }: { validationCode?: string; currentStep: Ref<VerificationFormStep>; }): Promise<void> {
    try {
        await showLoader('invite');
        if (!validationCode) throw new Error();
        
        currentValidationCode.value = validationCode;
        
        const [inviteResponse, questionResponse] = await Promise.all([
            axios.post<ContactUserAuthViewModel>(`/auth/invite/${props.inviteKey}`, { validationCode }),
            axios.get<ContactUserSecurityQuestion[]>('/auth/security-questions'),
        ]);
        securityQuestions.value = questionResponse.data;
        if (inviteResponse.status === 204) {
            // expired, resend
            currentStep.value = VerificationFormStep.ResendInvite;
        } else if (inviteResponse.status !== 200) {
            throw 'Invalid invite';
        } else {
            currentStep.value = VerificationFormStep.FormEntry;
        }
    } catch (e) {
        await showAlert({
            text: 'Unable to load invite, please try again',
            type: 'error'
        });
    } finally {
        await hideLoader('invite');
    }
}

async function onRegister(): Promise<void> {
    await showAlert({text: 'User registered, log in to continue', type: 'success'});
    await router.push({
        path: '/login',
        query: {
            facilityType: ExternalFacilityType.NhMessaging
        }
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContactVerificationForm, {
    "contact-key": _ctx.inviteKey,
    "verify-type": "invite",
    "form-title": "Portal Invite",
    onLoadForm: loadForm
  }, {
    default: _withCtx(() => [
      _createVNode(InviteForm, {
        "invite-key": _ctx.inviteKey,
        "security-questions": securityQuestions.value,
        "validation-code": currentValidationCode.value,
        "form-title": "Register User",
        onRegistered: onRegister
      }, null, 8, ["invite-key", "security-questions", "validation-code"])
    ]),
    _: 1
  }, 8, ["contact-key"]))
}
}

})